// src/config/skillCategoryIcons.jsx
/**
 * Skill Category Icon Configuration
 * Centralized mapping of skill categories to Material-UI icons
 */
import CodeIcon from '@mui/icons-material/Code';
import CloudIcon from '@mui/icons-material/Cloud';
import StorageIcon from '@mui/icons-material/Storage';
import SecurityIcon from '@mui/icons-material/Security';
import ListAltIcon from '@mui/icons-material/ListAlt';
import SchoolIcon from '@mui/icons-material/School';
import WorkIcon from '@mui/icons-material/Work';
import VerifiedIcon from '@mui/icons-material/Verified';
import BuildIcon from '@mui/icons-material/Build';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import DescriptionIcon from '@mui/icons-material/Description';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CategoryIcon from '@mui/icons-material/Category';
import DataObjectIcon from '@mui/icons-material/DataObject';
import BusinessIcon from '@mui/icons-material/Business';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import PsychologyIcon from '@mui/icons-material/Psychology';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import SettingsIcon from '@mui/icons-material/Settings';
import SupportIcon from '@mui/icons-material/Support';
import EngineeringIcon from '@mui/icons-material/Engineering';

/**
 * Category icon mapping configuration
 * Maps category IDs to their corresponding Material-UI icon components
 */
export const SKILL_CATEGORY_ICONS = {
  // Architecture categories
  architecture_design: AccountTreeIcon,
  solution_architecture: DesignServicesIcon,
  system_design: DesignServicesIcon,

  // Integration categories
  systems_integration: DeviceHubIcon,
  data_integration: StorageIcon,

  // Development categories
  development: CodeIcon,
  software_development: CodeIcon,

  // Cloud & infrastructure categories
  cloud_infra: CloudIcon,
  cloud_computing: CloudIcon,
  infrastructure: BuildIcon,

  // Data categories
  data_analytics: AnalyticsIcon,
  data_science: DataObjectIcon,
  database: StorageIcon,

  // Security categories
  security: SecurityIcon,
  cybersecurity: SecurityIcon,

  // Documentation categories
  documentation: DescriptionIcon,
  technical_documentation: DescriptionIcon,

  // Business categories
  business_analysis: AssessmentIcon,
  business_process: BusinessIcon,

  // Methodology categories
  methodology: ListAltIcon,
  project_management: ListAltIcon,

  // Support categories
  problem_resolution: SupportIcon,
  technical_support: SupportIcon,

  // Strategy categories
  technical_strategy: PsychologyIcon,
  strategy: PsychologyIcon,

  // Engineering categories
  engineering: EngineeringIcon,

  // Default/uncategorized
  uncategorized: CategoryIcon,
  default: SettingsIcon
};

/**
 * Get icon component for a given category ID
 * @param {string} categoryId - Category identifier
 * @returns {React.Component} Material-UI icon component
 */
export const getCategoryIcon = (categoryId) => {
  return SKILL_CATEGORY_ICONS[categoryId] || SKILL_CATEGORY_ICONS.default;
};

/**
 * Skill source icons for different types
 */
export const SKILL_SOURCE_ICONS = {
  project: WorkIcon,
  certification: VerifiedIcon,
  training: SchoolIcon
};

/**
 * Get icon component for a skill source type
 * @param {string} sourceType - Source type ('project', 'certification', 'training')
 * @returns {React.Component} Material-UI icon component
 */
export const getSourceIcon = (sourceType) => {
  return SKILL_SOURCE_ICONS[sourceType] || null;
};
